import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login";
import { PrivateRoutes, PublicRoutes, PublicRoutes2, PublicRoutes3 } from "./utilities/PrivateRoutes";
import { Provider } from "react-redux";
import { newStore } from "@mywvglobal-shared/mywv-shared/store";
import storage from "redux-persist/lib/storage";
import { AlertProvider } from "./context/AlertContext";
import { PageLoaderNew } from "./components/atoms/Loader";
import "primeicons/primeicons.css";
import Home from "./components/pages/Home";
import { useTranslation } from "react-i18next";
import GlobalFont from "./components/molecule/GlobalFont";
const CommunityHomeView = React.lazy(() => import("./components/pages/CommunityHomeView"));
const GetHelp = React.lazy(() => import("./components/pages/GetHelp"));
const ChoosenLayout = React.lazy(() => import("./components/pages/ChoosenLayout"));
const SignleChosenSponsorChild = React.lazy(() => import("./components/pages/SingleChosenSponsorChild"));
const AccountView = React.lazy(() => import("./components/pages/AccountView"));
const OpenCommunityStation = React.lazy(() => import("./components/pages/OpenCommunityStation"));
const ProjectCelebration = React.lazy(() => import("./components/pages/ProjectCelebration"));
const OpenChildStation = React.lazy(() => import("./components/pages/openChildStation"));
const OpenStation = React.lazy(() => import("./components/pages/OpenStation"));
const SendAGift = React.lazy(() => import("./components/pages/SendAGift"));
const OpenConnectView = React.lazy(() => import("./components/pages/OpenConnectView"));
const NewsAndStories = React.lazy(() => import("./components/pages/NewsAndStories"));
const PageNotFound = React.lazy(() => import("./components/pages/PageNotFound"));
const PastSponsoredChildView = React.lazy(() => import("./components/pages/PastSponsoredChildView"));
const { store } = newStore(storage);

function App() {
  const { t } = useTranslation();
  return (
    <Provider store={store}>
      <AlertProvider>
        <GlobalFont></GlobalFont>
        <Suspense fallback={<PageLoaderNew fulldiv>
          <div className="spinner--wv-star">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
          <span className="loader_text">{t("Pleasewait")}</span>
        </PageLoaderNew>}>
          <BrowserRouter basename="/WVRetentionPortal/">
            <Routes>
              <Route element={<PublicRoutes />}>
                <Route exact="true" path="/" element={<Login />} />
              </Route>
              <Route element={<PublicRoutes2 />}>
                <Route exact="true" path="/:soname" element={<Login />} />
              </Route>
              <Route element={<PublicRoutes3 />}>
                <Route path="/getHelp" element={<GetHelp />} />
              </Route>
              <Route element={<PrivateRoutes />}>
                <Route path="/chosen-layout/:id" element={<ChoosenLayout />} />
              </Route>
              <Route element={<PrivateRoutes />}>
                <Route path="/chosen-children/" element={<SignleChosenSponsorChild />} />
              </Route>
              <Route element={<PrivateRoutes home />}>
                <Route path="/home" element={<Home />} />
              </Route>
              <Route element={<PrivateRoutes home/>}>
                   <Route path="/project-celebration/:childcode" element={<ProjectCelebration/>} />
               </Route> 
              <Route element={<PrivateRoutes />}>
                <Route path="/communityhomeview/:childcode" element={<CommunityHomeView />} />
                <Route element={<OpenStation />} >
                  <Route path="/community/station/:childcode/:stationid/" />
                  <Route path="/community/station/:childcode/:stationid/OurProgress" />
                  <Route path="/community/station/:childcode/:stationid/ExploreStories" />
                </Route>
                <Route element={<OpenChildStation />}>
                  <Route path="/community/childprofile/:childcode/:stationid" />
                  <Route path="/community/childprofile/:childcode/:stationid/MyProgress" />
                  <Route path="/community/childprofile/:childcode/:stationid/AboutMe" />
                  <Route path="/community/childprofile/:childcode/:stationid/MyDailyLife" />
                  <Route path="/community/childprofile/:childcode/:stationid/HowIGrown" />
                </Route>
                <Route element={<PastSponsoredChildView />}>
                  <Route path="/community/pastSponsoredChild/:pastchildcode" />
                  <Route path="/community/pastSponsoredChild/:pastchildcode/HowIGrown" />
                </Route>
                <Route element={<OpenCommunityStation />}>
                  <Route path="/community/childcommunity/:childcode/:stationid" />
                  <Route path="/community/childcommunity/:childcode/:stationid/OurProgress" />
                  <Route path="/community/childcommunity/:childcode/:stationid/AboutCommunity" />
                  <Route path="/community/childcommunity/:childcode/:stationid/AboutCountry" />
                  <Route path="/community/childcommunity/:childcode/:stationid/LifeandCulture" />
                  <Route path="/community/childcommunity/:childcode/:stationid/MediaGallery" />
                </Route>
                <Route element={<AccountView />}>
                  <Route path="/myaccount" />
                  <Route path="/notification" />
                  <Route path="/sponsorships" />
                  <Route path="/donations" />
                  <Route path="/security" />
                </Route>
                <Route element={<OpenConnectView />}>
                  <Route path="/connect/:childcode" />
                  <Route path="/connect/:childcode/WriteAmessage" />
                  <Route path="/connect/:childcode/LetterJourney" />
                  <Route path="/connect/:childcode/FAQs" />
                  <Route path="/connect/:childcode/TipsForWriting" />
                </Route>
                <Route element={<SendAGift />}>
                  <Route path="/sendAGift/:childcode" />
                  <Route path="/sendAGift/:childcode/gift" />
                  <Route path="/sendAGift/:childcode/donate" />
                </Route>
                <Route path="/donate" element={<SendAGift />} />
                <Route path="/newsandstories" element={<NewsAndStories />} />
                <Route path="/PageNotFound" element={<PageNotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </Suspense>
      </AlertProvider>
    </Provider>
  );
}

export default App;
